"use client";

import React from "react";
import { cn } from "utils";

export interface ChatStructuredCardShellProps {
  /** 卡片根节点 class */
  className?: string;
  children: React.ReactNode;
  "data-testid"?: string;
}

/**
 * Chat 结构化卡片外框：背景、圆角、描边，与设计稿 Frame 一致。
 */
export const ChatStructuredCardShell: React.FC<
  ChatStructuredCardShellProps
> = ({ className, children, "data-testid": dataTestId }) => (
  <div
    className={cn("flex w-full flex-col p-3", className)}
    data-testid={dataTestId}
  >
    {children}
  </div>
);
